export default "__VITE_ASSET__BADQJt82__"